"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICONS = exports.IMAGES = exports.useGlobalStyles = exports.useChartColors = exports.useGlobalPaperTheme = void 0;
exports.NextepLogo = NextepLogo;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const Helper_1 = require("./Helper");
const ThemeContext_1 = require("./ThemeContext");
const ResponsiveContext_1 = require("./contexts/ResponsiveContext");
const NextepColor_svg_1 = __importDefault(require("./images/NextepColor.svg"));
const NextepWhite_svg_1 = __importDefault(require("./images/NextepWhite.svg"));
const LoginBackground_png_1 = __importDefault(require("./images/LoginBackground.png"));
const LoginBackground_web_png_1 = __importDefault(require("./images/LoginBackground.web.png"));
const TelusHealth_png_1 = __importDefault(require("./images/benefits/TelusHealth.png"));
const AutumnHomeBackground_png_1 = __importDefault(require("./images/autumn/AutumnHomeBackground.png"));
const AutumnHomeBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnHomeBackground.web.png"));
const AutumnHelpBackground_png_1 = __importDefault(require("./images/autumn/AutumnHelpBackground.png"));
const AutumnHelpBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnHelpBackground.web.png"));
const AutumnSettingsBackground_png_1 = __importDefault(require("./images/autumn/AutumnSettingsBackground.png"));
const AutumnSettingsBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnSettingsBackground.web.png"));
const AutumnTaxesBackground_png_1 = __importDefault(require("./images/autumn/AutumnTaxesBackground.png"));
const AutumnTaxesBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnTaxesBackground.web.png"));
const AutumnPayBackground_png_1 = __importDefault(require("./images/autumn/AutumnPayBackground.png"));
const AutumnPayBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnPayBackground.web.png"));
const AutumnBenefitsBackground_png_1 = __importDefault(require("./images/autumn/AutumnBenefitsBackground.png"));
const AutumnBenefitsBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnBenefitsBackground.web.png"));
const AutumnInformationBackground_png_1 = __importDefault(require("./images/autumn/AutumnInformationBackground.png"));
const AutumnInformationBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnInformationBackground.web.png"));
const AutumnTimeBackground_png_1 = __importDefault(require("./images/autumn/AutumnTimeBackground.png"));
const AutumnTimeBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnTimeBackground.web.png"));
const AutumnCompanyBackground_png_1 = __importDefault(require("./images/autumn/AutumnCompanyBackground.png"));
const AutumnCompanyBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnCompanyBackground.web.png"));
const AutumnRenewalBackground_png_1 = __importDefault(require("./images/autumn/AutumnRenewalBackground.png"));
const AutumnRenewalBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnRenewalBackground.web.png"));
const AutumnAnnouncementsBackground_png_1 = __importDefault(require("./images/autumn/AutumnAnnouncementsBackground.png"));
const AutumnAnnouncementsBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnAnnouncementsBackground.web.png"));
const AutumnRiskAndComplianceBackground_png_1 = __importDefault(require("./images/autumn/AutumnRiskAndComplianceBackground.png"));
const AutumnRiskAndComplianceBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnRiskAndComplianceBackground.web.png"));
const AutumnEmployeeManagementBackground_png_1 = __importDefault(require("./images/autumn/AutumnEmployeeManagementBackground.png"));
const AutumnEmployeeManagementBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnEmployeeManagementBackground.web.png"));
const AutumnPtoApprovalsBackground_png_1 = __importDefault(require("./images/autumn/AutumnPtoApprovalsBackground.png"));
const AutumnPtoApprovalsBackground_web_png_1 = __importDefault(require("./images/autumn/AutumnPtoApprovalsBackground.web.png"));
const SummerHomeBackground_png_1 = __importDefault(require("./images/summer/SummerHomeBackground.png"));
const SummerHomeBackground_web_png_1 = __importDefault(require("./images/summer/SummerHomeBackground.web.png"));
const SummerHelpBackground_png_1 = __importDefault(require("./images/summer/SummerHelpBackground.png"));
const SummerHelpBackground_web_png_1 = __importDefault(require("./images/summer/SummerHelpBackground.web.png"));
const SummerSettingsBackground_png_1 = __importDefault(require("./images/summer/SummerSettingsBackground.png"));
const SummerSettingsBackground_web_png_1 = __importDefault(require("./images/summer/SummerSettingsBackground.web.png"));
const SummerTaxesBackground_png_1 = __importDefault(require("./images/summer/SummerTaxesBackground.png"));
const SummerTaxesBackground_web_png_1 = __importDefault(require("./images/summer/SummerTaxesBackground.web.png"));
const SummerPayBackground_png_1 = __importDefault(require("./images/summer/SummerPayBackground.png"));
const SummerPayBackground_web_png_1 = __importDefault(require("./images/summer/SummerPayBackground.web.png"));
const SummerBenefitsBackground_png_1 = __importDefault(require("./images/summer/SummerBenefitsBackground.png"));
const SummerBenefitsBackground_web_png_1 = __importDefault(require("./images/summer/SummerBenefitsBackground.web.png"));
const SummerInformationBackground_png_1 = __importDefault(require("./images/summer/SummerInformationBackground.png"));
const SummerInformationBackground_web_png_1 = __importDefault(require("./images/summer/SummerInformationBackground.web.png"));
const SummerTimeBackground_png_1 = __importDefault(require("./images/summer/SummerTimeBackground.png"));
const SummerTimeBackground_web_png_1 = __importDefault(require("./images/summer/SummerTimeBackground.web.png"));
const SummerCompanyBackground_png_1 = __importDefault(require("./images/summer/SummerCompanyBackground.png"));
const SummerCompanyBackground_web_png_1 = __importDefault(require("./images/summer/SummerCompanyBackground.web.png"));
const SummerRenewalBackground_png_1 = __importDefault(require("./images/summer/SummerRenewalBackground.png"));
const SummerRenewalBackground_web_png_1 = __importDefault(require("./images/summer/SummerRenewalBackground.web.png"));
const SummerAnnouncementsBackground_png_1 = __importDefault(require("./images/summer/SummerAnnouncementsBackground.png"));
const SummerAnnouncementsBackground_web_png_1 = __importDefault(require("./images/summer/SummerAnnouncementsBackground.web.png"));
const SummerRiskAndComplianceBackground_png_1 = __importDefault(require("./images/summer/SummerRiskAndComplianceBackground.png"));
const SummerRiskAndComplianceBackground_web_png_1 = __importDefault(require("./images/summer/SummerRiskAndComplianceBackground.web.png"));
const SummerEmployeeManagementBackground_png_1 = __importDefault(require("./images/summer/SummerEmployeeManagementBackground.png"));
const SummerEmployeeManagementBackground_web_png_1 = __importDefault(require("./images/summer/SummerEmployeeManagementBackground.web.png"));
const SummerPtoApprovalsBackground_png_1 = __importDefault(require("./images/summer/SummerPtoApprovalsBackground.png"));
const SummerPtoApprovalsBackground_web_png_1 = __importDefault(require("./images/summer/SummerPtoApprovalsBackground.web.png"));
const WinterHomeBackground_png_1 = __importDefault(require("./images/winter/WinterHomeBackground.png"));
const WinterHomeBackground_web_png_1 = __importDefault(require("./images/winter/WinterHomeBackground.web.png"));
const WinterHelpBackground_png_1 = __importDefault(require("./images/winter/WinterHelpBackground.png"));
const WinterHelpBackground_web_png_1 = __importDefault(require("./images/winter/WinterHelpBackground.web.png"));
const WinterSettingsBackground_png_1 = __importDefault(require("./images/winter/WinterSettingsBackground.png"));
const WinterSettingsBackground_web_png_1 = __importDefault(require("./images/winter/WinterSettingsBackground.web.png"));
const WinterTaxesBackground_png_1 = __importDefault(require("./images/winter/WinterTaxesBackground.png"));
const WinterTaxesBackground_web_png_1 = __importDefault(require("./images/winter/WinterTaxesBackground.web.png"));
const WinterPayBackground_png_1 = __importDefault(require("./images/winter/WinterPayBackground.png"));
const WinterPayBackground_web_png_1 = __importDefault(require("./images/winter/WinterPayBackground.web.png"));
const WinterBenefitsBackground_png_1 = __importDefault(require("./images/winter/WinterBenefitsBackground.png"));
const WinterBenefitsBackground_web_png_1 = __importDefault(require("./images/winter/WinterBenefitsBackground.web.png"));
const WinterInformationBackground_png_1 = __importDefault(require("./images/winter/WinterInformationBackground.png"));
const WinterInformationBackground_web_png_1 = __importDefault(require("./images/winter/WinterInformationBackground.web.png"));
const WinterTimeBackground_png_1 = __importDefault(require("./images/winter/WinterTimeBackground.png"));
const WinterTimeBackground_web_png_1 = __importDefault(require("./images/winter/WinterTimeBackground.web.png"));
const WinterCompanyBackground_png_1 = __importDefault(require("./images/winter/WinterCompanyBackground.png"));
const WinterCompanyBackground_web_png_1 = __importDefault(require("./images/winter/WinterCompanyBackground.web.png"));
const WinterRenewalBackground_png_1 = __importDefault(require("./images/winter/WinterRenewalBackground.png"));
const WinterRenewalBackground_web_png_1 = __importDefault(require("./images/winter/WinterRenewalBackground.web.png"));
const WinterAnnouncementsBackground_png_1 = __importDefault(require("./images/winter/WinterAnnouncementsBackground.png"));
const WinterAnnouncementsBackground_web_png_1 = __importDefault(require("./images/winter/WinterAnnouncementsBackground.web.png"));
const WinterRiskAndComplianceBackground_png_1 = __importDefault(require("./images/winter/WinterRiskAndComplianceBackground.png"));
const WinterRiskAndComplianceBackground_web_png_1 = __importDefault(require("./images/winter/WinterRiskAndComplianceBackground.web.png"));
const WinterEmployeeManagementBackground_png_1 = __importDefault(require("./images/winter/WinterEmployeeManagementBackground.png"));
const WinterEmployeeManagementBackground_web_png_1 = __importDefault(require("./images/winter/WinterEmployeeManagementBackground.web.png"));
const WinterPtoApprovalsBackground_png_1 = __importDefault(require("./images/winter/WinterPtoApprovalsBackground.png"));
const WinterPtoApprovalsBackground_web_png_1 = __importDefault(require("./images/winter/WinterPtoApprovalsBackground.web.png"));
const BannerIcon_png_1 = __importDefault(require("./images/BannerIcon.png"));
const faApartment_1 = require("@fortawesome/pro-solid-svg-icons/faApartment");
const faApartment_2 = require("@fortawesome/pro-regular-svg-icons/faApartment");
const faArrowLeft_1 = require("@fortawesome/pro-solid-svg-icons/faArrowLeft");
const faArrowRight_1 = require("@fortawesome/pro-solid-svg-icons/faArrowRight");
const faArrowRightFromBracket_1 = require("@fortawesome/pro-regular-svg-icons/faArrowRightFromBracket");
const faBell_1 = require("@fortawesome/pro-regular-svg-icons/faBell");
const faBriefcase_1 = require("@fortawesome/pro-regular-svg-icons/faBriefcase");
const faCalendarPlus_1 = require("@fortawesome/pro-regular-svg-icons/faCalendarPlus");
const faCircleQuestion_1 = require("@fortawesome/pro-solid-svg-icons/faCircleQuestion");
const faCircleQuestion_2 = require("@fortawesome/pro-regular-svg-icons/faCircleQuestion");
const faChevronLeft_1 = require("@fortawesome/pro-solid-svg-icons/faChevronLeft");
const faChevronRight_1 = require("@fortawesome/pro-solid-svg-icons/faChevronRight");
const faChevronRight_2 = require("@fortawesome/pro-regular-svg-icons/faChevronRight");
const faChevronLeft_2 = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");
const faChevronUp_1 = require("@fortawesome/pro-regular-svg-icons/faChevronUp");
const faChevronDown_1 = require("@fortawesome/pro-regular-svg-icons/faChevronDown");
const faFileContract_1 = require("@fortawesome/pro-solid-svg-icons/faFileContract");
const faFileContract_2 = require("@fortawesome/pro-regular-svg-icons/faFileContract");
const faFile_1 = require("@fortawesome/pro-regular-svg-icons/faFile");
const faMagnifyingGlass_1 = require("@fortawesome/pro-solid-svg-icons/faMagnifyingGlass");
const faFolderMagnifyingGlass_1 = require("@fortawesome/pro-duotone-svg-icons/faFolderMagnifyingGlass");
const faFolderXmark_1 = require("@fortawesome/pro-duotone-svg-icons/faFolderXmark");
const faQuestion_1 = require("@fortawesome/pro-regular-svg-icons/faQuestion");
const faFlag_1 = require("@fortawesome/pro-solid-svg-icons/faFlag");
const faGifts_1 = require("@fortawesome/pro-duotone-svg-icons/faGifts");
const faHouseBlank_1 = require("@fortawesome/pro-solid-svg-icons/faHouseBlank");
const faHouseBlank_2 = require("@fortawesome/pro-regular-svg-icons/faHouseBlank");
const faKey_1 = require("@fortawesome/pro-regular-svg-icons/faKey");
const faListUl_1 = require("@fortawesome/pro-regular-svg-icons/faListUl");
const faMessages_1 = require("@fortawesome/pro-regular-svg-icons/faMessages");
const faPhoneVolume_1 = require("@fortawesome/pro-regular-svg-icons/faPhoneVolume");
const faMoneyBill1_1 = require("@fortawesome/pro-solid-svg-icons/faMoneyBill1");
const faMoneyCheckDollar_1 = require("@fortawesome/pro-regular-svg-icons/faMoneyCheckDollar");
const faMoneyCheckDollar_2 = require("@fortawesome/pro-solid-svg-icons/faMoneyCheckDollar");
const faPiggyBank_1 = require("@fortawesome/pro-regular-svg-icons/faPiggyBank");
const faPiggyBank_2 = require("@fortawesome/pro-duotone-svg-icons/faPiggyBank");
const faPlus_1 = require("@fortawesome/pro-regular-svg-icons/faPlus");
const faHyphen_1 = require("@fortawesome/pro-solid-svg-icons/faHyphen");
const faRoad_1 = require("@fortawesome/pro-solid-svg-icons/faRoad");
const faUser_1 = require("@fortawesome/pro-solid-svg-icons/faUser");
const faUser_2 = require("@fortawesome/pro-regular-svg-icons/faUser");
const faUserPen_1 = require("@fortawesome/pro-regular-svg-icons/faUserPen");
const faXmark_1 = require("@fortawesome/pro-regular-svg-icons/faXmark");
const faBuildingColumns_1 = require("@fortawesome/pro-regular-svg-icons/faBuildingColumns");
const faBuildingColumns_2 = require("@fortawesome/pro-solid-svg-icons/faBuildingColumns");
const faBriefcaseMedical_1 = require("@fortawesome/pro-solid-svg-icons/faBriefcaseMedical");
const faPen_1 = require("@fortawesome/pro-regular-svg-icons/faPen");
const faTrashCan_1 = require("@fortawesome/pro-regular-svg-icons/faTrashCan");
const faCheck_1 = require("@fortawesome/pro-solid-svg-icons/faCheck");
const faCheck_2 = require("@fortawesome/pro-regular-svg-icons/faCheck");
const faCheck_3 = require("@fortawesome/pro-duotone-svg-icons/faCheck");
const faInfo_1 = require("@fortawesome/pro-regular-svg-icons/faInfo");
const faBuilding_1 = require("@fortawesome/pro-solid-svg-icons/faBuilding");
const faInfoCircle_1 = require("@fortawesome/pro-regular-svg-icons/faInfoCircle");
const faInfoCircle_2 = require("@fortawesome/pro-solid-svg-icons/faInfoCircle");
const faCircleCheck_1 = require("@fortawesome/pro-solid-svg-icons/faCircleCheck");
const faCircleExclamation_1 = require("@fortawesome/pro-solid-svg-icons/faCircleExclamation");
const faCircleExclamation_2 = require("@fortawesome/pro-regular-svg-icons/faCircleExclamation");
const faSquareUser_1 = require("@fortawesome/pro-duotone-svg-icons/faSquareUser");
const faCalendar_1 = require("@fortawesome/pro-regular-svg-icons/faCalendar");
const faCircle_1 = require("@fortawesome/pro-regular-svg-icons/faCircle");
const faCircle_2 = require("@fortawesome/pro-solid-svg-icons/faCircle");
const faAddressCard_1 = require("@fortawesome/pro-solid-svg-icons/faAddressCard");
const faKey_2 = require("@fortawesome/pro-solid-svg-icons/faKey");
const faHeartPulse_1 = require("@fortawesome/pro-regular-svg-icons/faHeartPulse");
const faHeartPulse_2 = require("@fortawesome/pro-solid-svg-icons/faHeartPulse");
const faHeartPulse_3 = require("@fortawesome/pro-duotone-svg-icons/faHeartPulse");
const faEye_1 = require("@fortawesome/pro-regular-svg-icons/faEye");
const faEyeSlash_1 = require("@fortawesome/pro-regular-svg-icons/faEyeSlash");
const faTooth_1 = require("@fortawesome/pro-regular-svg-icons/faTooth");
const faTooth_2 = require("@fortawesome/pro-solid-svg-icons/faTooth");
const faTooth_3 = require("@fortawesome/pro-duotone-svg-icons/faTooth");
const faMegaphone_1 = require("@fortawesome/pro-solid-svg-icons/faMegaphone");
const faMegaphone_2 = require("@fortawesome/pro-duotone-svg-icons/faMegaphone");
const faMegaphone_3 = require("@fortawesome/pro-regular-svg-icons/faMegaphone");
const faGlasses_1 = require("@fortawesome/pro-regular-svg-icons/faGlasses");
const faGlasses_2 = require("@fortawesome/pro-solid-svg-icons/faGlasses");
const faGlasses_3 = require("@fortawesome/pro-duotone-svg-icons/faGlasses");
const faGear_1 = require("@fortawesome/pro-solid-svg-icons/faGear");
const faGear_2 = require("@fortawesome/pro-regular-svg-icons/faGear");
const faHandshakeAngle_1 = require("@fortawesome/pro-duotone-svg-icons/faHandshakeAngle");
const faFileLines_1 = require("@fortawesome/pro-regular-svg-icons/faFileLines");
const faFileLines_2 = require("@fortawesome/pro-light-svg-icons/faFileLines");
const faArrowDownToLine_1 = require("@fortawesome/pro-regular-svg-icons/faArrowDownToLine");
const faBookOpen_1 = require("@fortawesome/pro-regular-svg-icons/faBookOpen");
const faArrowUpRightFromSquare_1 = require("@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare");
const faComputer_1 = require("@fortawesome/pro-duotone-svg-icons/faComputer");
const faMoneyBill1_2 = require("@fortawesome/pro-duotone-svg-icons/faMoneyBill1");
const faArrowRightToBracket_1 = require("@fortawesome/pro-solid-svg-icons/faArrowRightToBracket");
const faArrowRightFromBracket_2 = require("@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket");
const faFileUser_1 = require("@fortawesome/pro-duotone-svg-icons/faFileUser");
const faAlarmClock_1 = require("@fortawesome/pro-duotone-svg-icons/faAlarmClock");
const faAlarmClock_2 = require("@fortawesome/pro-solid-svg-icons/faAlarmClock");
const faAlarmClock_3 = require("@fortawesome/pro-regular-svg-icons/faAlarmClock");
const faCopy_1 = require("@fortawesome/pro-regular-svg-icons/faCopy");
const faCopy_2 = require("@fortawesome/pro-solid-svg-icons/faCopy");
const faSignature_1 = require("@fortawesome/pro-regular-svg-icons/faSignature");
const faMoneyCheckDollar_3 = require("@fortawesome/pro-duotone-svg-icons/faMoneyCheckDollar");
const faKey_3 = require("@fortawesome/pro-duotone-svg-icons/faKey");
const faFolderTree_1 = require("@fortawesome/pro-duotone-svg-icons/faFolderTree");
const faFolderTree_2 = require("@fortawesome/pro-solid-svg-icons/faFolderTree");
const faClipboardQuestion_1 = require("@fortawesome/pro-duotone-svg-icons/faClipboardQuestion");
const faIslandTropical_1 = require("@fortawesome/pro-duotone-svg-icons/faIslandTropical");
const faBooks_1 = require("@fortawesome/pro-duotone-svg-icons/faBooks");
const faScaleBalanced_1 = require("@fortawesome/pro-duotone-svg-icons/faScaleBalanced");
const faScaleBalanced_2 = require("@fortawesome/pro-regular-svg-icons/faScaleBalanced");
const faBars_1 = require("@fortawesome/pro-solid-svg-icons/faBars");
const faCaretDown_1 = require("@fortawesome/pro-solid-svg-icons/faCaretDown");
const faPeopleGroup_1 = require("@fortawesome/pro-duotone-svg-icons/faPeopleGroup");
const faPerson_1 = require("@fortawesome/pro-solid-svg-icons/faPerson");
const faPersonDress_1 = require("@fortawesome/pro-solid-svg-icons/faPersonDress");
const faPen_2 = require("@fortawesome/pro-duotone-svg-icons/faPen");
const faBriefcase_2 = require("@fortawesome/pro-duotone-svg-icons/faBriefcase");
const faCalendarCirclePlus_1 = require("@fortawesome/pro-duotone-svg-icons/faCalendarCirclePlus");
const faCalendarCheck_1 = require("@fortawesome/pro-duotone-svg-icons/faCalendarCheck");
const faCalendarXmark_1 = require("@fortawesome/pro-duotone-svg-icons/faCalendarXmark");
const faCalendarClock_1 = require("@fortawesome/pro-duotone-svg-icons/faCalendarClock");
const faRectangleHistoryCircleUser_1 = require("@fortawesome/pro-solid-svg-icons/faRectangleHistoryCircleUser");
const faClock_1 = require("@fortawesome/pro-regular-svg-icons/faClock");
const faCalendar_2 = require("@fortawesome/pro-solid-svg-icons/faCalendar");
const faHouseUser_1 = require("@fortawesome/pro-duotone-svg-icons/faHouseUser");
const faHouseUser_2 = require("@fortawesome/pro-solid-svg-icons/faHouseUser");
const faBuildingColumns_3 = require("@fortawesome/pro-duotone-svg-icons/faBuildingColumns");
const faDollar_1 = require("@fortawesome/pro-solid-svg-icons/faDollar");
const react_native_paper_1 = require("react-native-paper");
const faIdCardClip_1 = require("@fortawesome/pro-solid-svg-icons/faIdCardClip");
const faMessageXmark_1 = require("@fortawesome/pro-duotone-svg-icons/faMessageXmark");
const faMessageCheck_1 = require("@fortawesome/pro-duotone-svg-icons/faMessageCheck");
const faHeadset_1 = require("@fortawesome/pro-duotone-svg-icons/faHeadset");
const faHeadset_2 = require("@fortawesome/pro-regular-svg-icons/faHeadset");
const faHeadset_3 = require("@fortawesome/pro-light-svg-icons/faHeadset");
const faPhoneVolume_2 = require("@fortawesome/pro-light-svg-icons/faPhoneVolume");
const faBriefcase_3 = require("@fortawesome/pro-light-svg-icons/faBriefcase");
const faMessages_2 = require("@fortawesome/pro-light-svg-icons/faMessages");
const faCalendarPlus_2 = require("@fortawesome/pro-light-svg-icons/faCalendarPlus");
const faMobileScreenButton_1 = require("@fortawesome/pro-solid-svg-icons/faMobileScreenButton");
const faLock_1 = require("@fortawesome/pro-regular-svg-icons/faLock");
const faEnvelope_1 = require("@fortawesome/pro-regular-svg-icons/faEnvelope");
const faEnvelope_2 = require("@fortawesome/pro-duotone-svg-icons/faEnvelope");
const faEnvelope_3 = require("@fortawesome/pro-light-svg-icons/faEnvelope");
const faPhone_1 = require("@fortawesome/pro-regular-svg-icons/faPhone");
const faBriefcaseBlank_1 = require("@fortawesome/pro-solid-svg-icons/faBriefcaseBlank");
const faLocationPin_1 = require("@fortawesome/pro-solid-svg-icons/faLocationPin");
const faLocationDot_1 = require("@fortawesome/pro-regular-svg-icons/faLocationDot");
const faFingerprint_1 = require("@fortawesome/pro-regular-svg-icons/faFingerprint");
const faCaretUp_1 = require("@fortawesome/pro-solid-svg-icons/faCaretUp");
const faQrcode_1 = require("@fortawesome/pro-regular-svg-icons/faQrcode");
const faFileCircleQuestion_1 = require("@fortawesome/pro-solid-svg-icons/faFileCircleQuestion");
const faPersonCircleQuestion_1 = require("@fortawesome/pro-solid-svg-icons/faPersonCircleQuestion");
const faPiggyBank_3 = require("@fortawesome/pro-solid-svg-icons/faPiggyBank");
const faCalendarCircleExclamation_1 = require("@fortawesome/pro-solid-svg-icons/faCalendarCircleExclamation");
const faIslandTropical_2 = require("@fortawesome/pro-solid-svg-icons/faIslandTropical");
const faCalendarCircleUser_1 = require("@fortawesome/pro-solid-svg-icons/faCalendarCircleUser");
const faShieldKeyhole_1 = require("@fortawesome/pro-solid-svg-icons/faShieldKeyhole");
const faShieldCheck_1 = require("@fortawesome/pro-solid-svg-icons/faShieldCheck");
const faFileCircleCheck_1 = require("@fortawesome/pro-solid-svg-icons/faFileCircleCheck");
const faChalkboardTeacher_1 = require("@fortawesome/pro-solid-svg-icons/faChalkboardTeacher");
const faChartUser_1 = require("@fortawesome/pro-duotone-svg-icons/faChartUser");
const faChartUser_2 = require("@fortawesome/pro-solid-svg-icons/faChartUser");
const faAndroid_1 = require("@fortawesome/free-brands-svg-icons/faAndroid");
const faApple_1 = require("@fortawesome/free-brands-svg-icons/faApple");
const faArrowRight_2 = require("@fortawesome/pro-regular-svg-icons/faArrowRight");
const faFileImport_1 = require("@fortawesome/pro-duotone-svg-icons/faFileImport");
const faFileShield_1 = require("@fortawesome/pro-duotone-svg-icons/faFileShield");
const faPollPeople_1 = require("@fortawesome/pro-duotone-svg-icons/faPollPeople");
const faGavel_1 = require("@fortawesome/pro-duotone-svg-icons/faGavel");
const faArrowUp_1 = require("@fortawesome/pro-solid-svg-icons/faArrowUp");
const faArrowDown_1 = require("@fortawesome/pro-solid-svg-icons/faArrowDown");
const faUpload_1 = require("@fortawesome/pro-solid-svg-icons/faUpload");
const faChartLineUp_1 = require("@fortawesome/pro-duotone-svg-icons/faChartLineUp");
const faFileCertificate_1 = require("@fortawesome/pro-duotone-svg-icons/faFileCertificate");
const faFileLines_3 = require("@fortawesome/pro-duotone-svg-icons/faFileLines");
const faFaceHeadBandage_1 = require("@fortawesome/pro-duotone-svg-icons/faFaceHeadBandage");
const faSackDollar_1 = require("@fortawesome/pro-duotone-svg-icons/faSackDollar");
const faStar_1 = require("@fortawesome/pro-solid-svg-icons/faStar");
const faStar_2 = require("@fortawesome/pro-regular-svg-icons/faStar");
const faClipboardMedical_1 = require("@fortawesome/pro-duotone-svg-icons/faClipboardMedical");
const faFilesMedical_1 = require("@fortawesome/pro-duotone-svg-icons/faFilesMedical");
const faCarBurst_1 = require("@fortawesome/pro-duotone-svg-icons/faCarBurst");
const faFileInvoiceDollar_1 = require("@fortawesome/pro-duotone-svg-icons/faFileInvoiceDollar");
const faChartPieSimpleCircleDollar_1 = require("@fortawesome/pro-duotone-svg-icons/faChartPieSimpleCircleDollar");
const faFileContract_3 = require("@fortawesome/pro-duotone-svg-icons/faFileContract");
const faPersonCirclePlus_1 = require("@fortawesome/pro-solid-svg-icons/faPersonCirclePlus");
const faPersonCircleMinus_1 = require("@fortawesome/pro-solid-svg-icons/faPersonCircleMinus");
const faPersonCirclePlus_2 = require("@fortawesome/pro-duotone-svg-icons/faPersonCirclePlus");
const faPersonCircleMinus_2 = require("@fortawesome/pro-duotone-svg-icons/faPersonCircleMinus");
const faCircleXmark_1 = require("@fortawesome/pro-solid-svg-icons/faCircleXmark");
const faCircleXmark_2 = require("@fortawesome/pro-regular-svg-icons/faCircleXmark");
const faPersonCirclePlus_3 = require("@fortawesome/pro-regular-svg-icons/faPersonCirclePlus");
const faPersonCircleMinus_3 = require("@fortawesome/pro-regular-svg-icons/faPersonCircleMinus");
const faBalloons_1 = require("@fortawesome/pro-duotone-svg-icons/faBalloons");
const faLocationPlus_1 = require("@fortawesome/pro-duotone-svg-icons/faLocationPlus");
const faLocationPen_1 = require("@fortawesome/pro-duotone-svg-icons/faLocationPen");
const faBuildings_1 = require("@fortawesome/pro-regular-svg-icons/faBuildings");
const faIdBadge_1 = require("@fortawesome/pro-regular-svg-icons/faIdBadge");
const faClipboardList_1 = require("@fortawesome/pro-duotone-svg-icons/faClipboardList");
const faClipboardList_2 = require("@fortawesome/pro-regular-svg-icons/faClipboardList");
const faMemo_1 = require("@fortawesome/pro-regular-svg-icons/faMemo");
const faMemo_2 = require("@fortawesome/pro-solid-svg-icons/faMemo");
const faEnvelopeOpenText_1 = require("@fortawesome/pro-duotone-svg-icons/faEnvelopeOpenText");
const faFaceViewfinder_1 = require("@fortawesome/pro-regular-svg-icons/faFaceViewfinder");
const faSquareCheck_1 = require("@fortawesome/pro-solid-svg-icons/faSquareCheck");
const faSquare_1 = require("@fortawesome/pro-regular-svg-icons/faSquare");
const faSquareA_1 = require("@fortawesome/pro-solid-svg-icons/faSquareA");
const faFilter_1 = require("@fortawesome/pro-regular-svg-icons/faFilter");
const faMoneyCheckDollarPen_1 = require("@fortawesome/pro-duotone-svg-icons/faMoneyCheckDollarPen");
const faAddressBook_1 = require("@fortawesome/pro-solid-svg-icons/faAddressBook");
const faWifiSlash_1 = require("@fortawesome/pro-solid-svg-icons/faWifiSlash");
const faAddressBook_2 = require("@fortawesome/pro-duotone-svg-icons/faAddressBook");
const faFolderGear_1 = require("@fortawesome/pro-duotone-svg-icons/faFolderGear");
const faFileMedical_1 = require("@fortawesome/pro-regular-svg-icons/faFileMedical");
const faFileMedical_2 = require("@fortawesome/pro-duotone-svg-icons/faFileMedical");
const faFileMedical_3 = require("@fortawesome/pro-solid-svg-icons/faFileMedical");
const faToggleOn_1 = require("@fortawesome/pro-solid-svg-icons/faToggleOn");
const faToggleOff_1 = require("@fortawesome/pro-solid-svg-icons/faToggleOff");
const faMoneyCheckEditAlt_1 = require("@fortawesome/pro-duotone-svg-icons/faMoneyCheckEditAlt");
const faCalendarEdit_1 = require("@fortawesome/pro-duotone-svg-icons/faCalendarEdit");
const faCalendarWeek_1 = require("@fortawesome/pro-regular-svg-icons/faCalendarWeek");
const faCalendarDays_1 = require("@fortawesome/pro-regular-svg-icons/faCalendarDays");
const faRepeat_1 = require("@fortawesome/pro-regular-svg-icons/faRepeat");
const faCircleHalfStroke_1 = require("@fortawesome/pro-duotone-svg-icons/faCircleHalfStroke");
const faMoon_1 = require("@fortawesome/pro-solid-svg-icons/faMoon");
const faSun_1 = require("@fortawesome/pro-solid-svg-icons/faSun");
const faDesktop_1 = require("@fortawesome/pro-solid-svg-icons/faDesktop");
const faMoneyBillTrendUp_1 = require("@fortawesome/pro-regular-svg-icons/faMoneyBillTrendUp");
const faChartDiagram_1 = require("@fortawesome/pro-duotone-svg-icons/faChartDiagram");
const faChartDiagram_2 = require("@fortawesome/pro-solid-svg-icons/faChartDiagram");
const faListTree_1 = require("@fortawesome/pro-solid-svg-icons/faListTree");
const faTags_1 = require("@fortawesome/pro-solid-svg-icons/faTags");
const faTags_2 = require("@fortawesome/pro-regular-svg-icons/faTags");
const faScrewdriverWrench_1 = require("@fortawesome/pro-solid-svg-icons/faScrewdriverWrench");
const faHandshake_1 = require("@fortawesome/pro-solid-svg-icons/faHandshake");
const faCalendarClock_2 = require("@fortawesome/pro-solid-svg-icons/faCalendarClock");
const faClipboardList_3 = require("@fortawesome/pro-solid-svg-icons/faClipboardList");
const faClipboardCheck_1 = require("@fortawesome/pro-regular-svg-icons/faClipboardCheck");
const faMoneyCheckPen_1 = require("@fortawesome/pro-regular-svg-icons/faMoneyCheckPen");
const faMoneyCheckDollarPen_2 = require("@fortawesome/pro-regular-svg-icons/faMoneyCheckDollarPen");
const faUsers_1 = require("@fortawesome/pro-regular-svg-icons/faUsers");
const faTable_1 = require("@fortawesome/pro-regular-svg-icons/faTable");
const faCalendarCheck_2 = require("@fortawesome/pro-regular-svg-icons/faCalendarCheck");
const faScrewdriverWrench_2 = require("@fortawesome/pro-regular-svg-icons/faScrewdriverWrench");
const faCakeCandles_1 = require("@fortawesome/pro-solid-svg-icons/faCakeCandles");
const faCakeCandles_2 = require("@fortawesome/pro-regular-svg-icons/faCakeCandles");
const faCakeCandles_3 = require("@fortawesome/pro-duotone-svg-icons/faCakeCandles");
const faCircleInfo_1 = require("@fortawesome/pro-duotone-svg-icons/faCircleInfo");
const faChalkboardTeacher_2 = require("@fortawesome/pro-duotone-svg-icons/faChalkboardTeacher");
const faTags_3 = require("@fortawesome/pro-duotone-svg-icons/faTags");
const faMemo_3 = require("@fortawesome/pro-duotone-svg-icons/faMemo");
const faAddressCard_2 = require("@fortawesome/pro-duotone-svg-icons/faAddressCard");
const faColumns_1 = require("@fortawesome/pro-regular-svg-icons/faColumns");
const faUnlink_1 = require("@fortawesome/pro-regular-svg-icons/faUnlink");
const faLink_1 = require("@fortawesome/pro-regular-svg-icons/faLink");
const faGoogle_1 = require("@fortawesome/free-brands-svg-icons/faGoogle");
const faCalendar_3 = require("@fortawesome/pro-duotone-svg-icons/faCalendar");
const faMicrosoft_1 = require("@fortawesome/free-brands-svg-icons/faMicrosoft");
const faMedal_1 = require("@fortawesome/pro-duotone-svg-icons/faMedal");
const faFileCertificate_2 = require("@fortawesome/pro-solid-svg-icons/faFileCertificate");
const faChartLineUp_2 = require("@fortawesome/pro-regular-svg-icons/faChartLineUp");
const faDisplayChartUp_1 = require("@fortawesome/pro-regular-svg-icons/faDisplayChartUp");
const faChartMixed_1 = require("@fortawesome/pro-solid-svg-icons/faChartMixed");
const faClock_2 = require("@fortawesome/pro-solid-svg-icons/faClock");
const faInfinity_1 = require("@fortawesome/pro-solid-svg-icons/faInfinity");
const faInfinity_2 = require("@fortawesome/pro-regular-svg-icons/faInfinity");
const faSquareUser_2 = require("@fortawesome/pro-solid-svg-icons/faSquareUser");
const padIconViewBox = (iconDef, paddingRight = 64) => {
    if (!iconDef || !iconDef.icon)
        return iconDef;
    const [width, height, ligatures, unicode, svgPath] = iconDef.icon;
    return {
        ...iconDef,
        icon: [
            width + paddingRight,
            height,
            ligatures,
            unicode,
            svgPath,
        ],
    };
};
const useGlobalPaperTheme = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return {
        ...react_native_paper_1.MD3LightTheme,
        colors: {
            ...react_native_paper_1.MD3LightTheme.colors,
            primary: THEME.Primary,
            secondary: THEME.Secondary,
            tertiary: THEME.Tertiary,
            background: THEME.Background,
            surface: THEME.Surface,
            surfaceVariant: THEME.SurfaceVariant,
            onSurface: THEME.OnSurface,
            onSurfaceVariant: THEME.OnSurfaceVariant,
            outline: THEME.Outline,
            surfaceDisabled: THEME.SurfaceDisabled,
            onSurfaceDisabled: THEME.OnSurfaceDisabled,
            primaryContainer: THEME.PrimaryContainer,
            secondaryContainer: THEME.SecondaryContainer,
            error: THEME.Red,
        },
    };
};
exports.useGlobalPaperTheme = useGlobalPaperTheme;
const useChartColors = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return [
        THEME.Primary,
        THEME.Secondary,
        THEME.Coral,
        THEME.Tertiary,
        THEME.Tangerine,
        THEME.Magenta,
        THEME.Slate,
        THEME.Teal,
        THEME.Butter,
        THEME.SkyBlue,
        THEME.CoolGray
    ];
};
exports.useChartColors = useChartColors;
const useGlobalStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        cardLandscape: {
            margin: 16
        },
        cardPortait: {
            marginHorizontal: 0,
            marginVertical: size != 'sm' ? 16 : 4
        },
        separator: {
            borderBottomColor: THEME.Black + '1A',
            borderBottomWidth: 1
        },
        notSelectable: {
            borderRadius: 0,
            userSelect: 'none'
        },
        none: {},
        button: {
            borderRadius: 4,
            paddingVertical: 13,
            userSelect: 'none'
        },
        pressedOpacity: {
            opacity: 0.6
        },
        pressed: {
            backgroundColor: THEME.Secondary + '11',
            borderColor: THEME.Secondary + 'aa'
        },
        input: {
            textAlign: 'auto',
            lineHeight: undefined
        }
    });
};
exports.useGlobalStyles = useGlobalStyles;
function NextepLogo({ width = 100, height = 30, ...props }) {
    const isDark = (0, ThemeContext_1.useIsDark)();
    const Logo = isDark ? NextepWhite_svg_1.default : NextepColor_svg_1.default;
    return (0, jsx_runtime_1.jsx)(Logo, { width: width, height: height, ...props });
}
exports.IMAGES = {
    LoginBackground: LoginBackground_png_1.default,
    LoginBackgroundWeb: LoginBackground_web_png_1.default,
    BannerIcon: BannerIcon_png_1.default,
    HomeBackground: Helper_1.Helper.isWinter() ? WinterHomeBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnHomeBackground_png_1.default : SummerHomeBackground_png_1.default,
    HomeBackgroundWeb: Helper_1.Helper.isWinter() ? WinterHomeBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnHomeBackground_web_png_1.default : SummerHomeBackground_web_png_1.default,
    HelpBackground: Helper_1.Helper.isWinter() ? WinterHelpBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnHelpBackground_png_1.default : SummerHelpBackground_png_1.default,
    HelpBackgroundWeb: Helper_1.Helper.isWinter() ? WinterHelpBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnHelpBackground_web_png_1.default : SummerHelpBackground_web_png_1.default,
    SettingsBackground: Helper_1.Helper.isWinter() ? WinterSettingsBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnSettingsBackground_png_1.default : SummerSettingsBackground_png_1.default,
    SettingsBackgroundWeb: Helper_1.Helper.isWinter() ? WinterSettingsBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnSettingsBackground_web_png_1.default : SummerSettingsBackground_web_png_1.default,
    TaxesBackground: Helper_1.Helper.isWinter() ? WinterTaxesBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnTaxesBackground_png_1.default : SummerTaxesBackground_png_1.default,
    TaxesBackgroundWeb: Helper_1.Helper.isWinter() ? WinterTaxesBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnTaxesBackground_web_png_1.default : SummerTaxesBackground_web_png_1.default,
    PayBackground: Helper_1.Helper.isWinter() ? WinterPayBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnPayBackground_png_1.default : SummerPayBackground_png_1.default,
    PayBackgroundWeb: Helper_1.Helper.isWinter() ? WinterPayBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnPayBackground_web_png_1.default : SummerPayBackground_web_png_1.default,
    BenefitsBackground: Helper_1.Helper.isWinter() ? WinterBenefitsBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnBenefitsBackground_png_1.default : SummerBenefitsBackground_png_1.default,
    BenefitsBackgroundWeb: Helper_1.Helper.isWinter() ? WinterBenefitsBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnBenefitsBackground_web_png_1.default : SummerBenefitsBackground_web_png_1.default,
    InformationBackground: Helper_1.Helper.isWinter() ? WinterInformationBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnInformationBackground_png_1.default : SummerInformationBackground_png_1.default,
    InformationBackgroundWeb: Helper_1.Helper.isWinter() ? WinterInformationBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnInformationBackground_web_png_1.default : SummerInformationBackground_web_png_1.default,
    TimeBackground: Helper_1.Helper.isWinter() ? WinterTimeBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnTimeBackground_png_1.default : SummerTimeBackground_png_1.default,
    TimeBackgroundWeb: Helper_1.Helper.isWinter() ? WinterTimeBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnTimeBackground_web_png_1.default : SummerTimeBackground_web_png_1.default,
    CompanyBackground: Helper_1.Helper.isWinter() ? WinterCompanyBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnCompanyBackground_png_1.default : SummerCompanyBackground_png_1.default,
    CompanyBackgroundWeb: Helper_1.Helper.isWinter() ? WinterCompanyBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnCompanyBackground_web_png_1.default : SummerCompanyBackground_web_png_1.default,
    PtoApprovalBackground: Helper_1.Helper.isWinter() ? WinterPtoApprovalsBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnPtoApprovalsBackground_png_1.default : SummerPtoApprovalsBackground_png_1.default,
    PtoApprovalBackgroundWeb: Helper_1.Helper.isWinter() ? WinterPtoApprovalsBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnPtoApprovalsBackground_web_png_1.default : SummerPtoApprovalsBackground_web_png_1.default,
    RenewalBackground: Helper_1.Helper.isWinter() ? WinterRenewalBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnRenewalBackground_png_1.default : SummerRenewalBackground_png_1.default,
    RenewalBackgroundWeb: Helper_1.Helper.isWinter() ? WinterRenewalBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnRenewalBackground_web_png_1.default : SummerRenewalBackground_web_png_1.default,
    AnnouncementsBackground: Helper_1.Helper.isWinter() ? WinterAnnouncementsBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnAnnouncementsBackground_png_1.default : SummerAnnouncementsBackground_png_1.default,
    AnnouncementsBackgroundWeb: Helper_1.Helper.isWinter() ? WinterAnnouncementsBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnAnnouncementsBackground_web_png_1.default : SummerAnnouncementsBackground_web_png_1.default,
    RiskAndComplianceBackground: Helper_1.Helper.isWinter() ? WinterRiskAndComplianceBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnRiskAndComplianceBackground_png_1.default : SummerRiskAndComplianceBackground_png_1.default,
    RiskAndComplianceBackgroundWeb: Helper_1.Helper.isWinter() ? WinterRiskAndComplianceBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnRiskAndComplianceBackground_web_png_1.default : SummerRiskAndComplianceBackground_web_png_1.default,
    EmployeeManagementBackground: Helper_1.Helper.isWinter() ? WinterEmployeeManagementBackground_png_1.default : Helper_1.Helper.isAutumn() ? AutumnEmployeeManagementBackground_png_1.default : SummerEmployeeManagementBackground_png_1.default,
    EmployeeManagementBackgroundWeb: Helper_1.Helper.isWinter() ? WinterEmployeeManagementBackground_web_png_1.default : Helper_1.Helper.isAutumn() ? AutumnEmployeeManagementBackground_web_png_1.default : SummerEmployeeManagementBackground_web_png_1.default,
    Benefits: {
        TelusHealth: TelusHealth_png_1.default
    }
};
exports.ICONS = {
    Solid: {
        Apartment: faApartment_1.faApartment,
        ArrowLeft: faArrowLeft_1.faArrowLeft,
        ArrowRight: faArrowRight_1.faArrowRight,
        Building: faBuilding_1.faBuilding,
        Calendar: faCalendar_2.faCalendar,
        CircleQuestion: faCircleQuestion_1.faCircleQuestion,
        ChevronLeft: faChevronLeft_1.faChevronLeft,
        ChevronRight: faChevronRight_1.faChevronRight,
        CaretUp: faCaretUp_1.faCaretUp,
        Flag: faFlag_1.faFlag,
        FileContract: faFileContract_1.faFileContract,
        File: faFile_1.faFile,
        HouseBlank: faHouseBlank_1.faHouseBlank,
        MoneyBill1: faMoneyBill1_1.faMoneyBill1,
        User: faUser_1.faUser,
        InfoCircle: faInfoCircle_2.faInfoCircle,
        Check: faCheck_1.faCheck,
        CircleCheck: faCircleCheck_1.faCircleCheck,
        Circle: faCircle_2.faCircle,
        CircleExclamation: faCircleExclamation_1.faCircleExclamation,
        BuildingColumns: faBuildingColumns_2.faBuildingColumns,
        PiggyBank: faPiggyBank_3.faPiggyBank,
        AddressCard: faAddressCard_1.faAddressCard,
        Key: faKey_2.faKey,
        ArrowRightToBracket: faArrowRightToBracket_1.faArrowRightToBracket,
        ArrowRightFromBracket: faArrowRightFromBracket_2.faArrowRightFromBracket,
        Bars: faBars_1.faBars,
        CaretDown: faCaretDown_1.faCaretDown,
        CalendarCircleUser: faCalendarCircleUser_1.faCalendarCircleUser,
        PersonCircleQuestion: faPersonCircleQuestion_1.faPersonCircleQuestion,
        IslandTropical: faIslandTropical_2.faIslandTropical,
        CalendarCircleExclamation: faCalendarCircleExclamation_1.faCalendarCircleExclamation,
        Person: faPerson_1.faPerson,
        ShieldKeyhole: faShieldKeyhole_1.faShieldKeyhole,
        ShieldCheck: faShieldCheck_1.faShieldCheck,
        RectangleHistoryCircleUser: faRectangleHistoryCircleUser_1.faRectangleHistoryCircleUser,
        Star: faStar_1.faStar,
        PersonDress: faPersonDress_1.faPersonDress,
        MoneyCheckDollar: faMoneyCheckDollar_2.faMoneyCheckDollar,
        Dollar: faDollar_1.faDollar,
        BriefcaseMedical: faBriefcaseMedical_1.faBriefcaseMedical,
        AlarmClock: faAlarmClock_2.faAlarmClock,
        HeartPulse: faHeartPulse_2.faHeartPulse,
        Tooth: faTooth_2.faTooth,
        Glasses: faGlasses_2.faGlasses,
        HouseUser: faHouseUser_2.faHouseUser,
        IdCardClip: faIdCardClip_1.faIdCardClip,
        MobileScreenButton: faMobileScreenButton_1.faMobileScreenButton,
        FileCircleQuestion: faFileCircleQuestion_1.faFileCircleQuestion,
        ChalkboardTeacher: faChalkboardTeacher_1.faChalkboardTeacher,
        Road: faRoad_1.faRoad,
        Hyphen: faHyphen_1.faHyphen,
        Megaphone: faMegaphone_1.faMegaphone,
        MagnifyingGlass: faMagnifyingGlass_1.faMagnifyingGlass,
        ArrowUp: faArrowUp_1.faArrowUp,
        ArrowDown: faArrowDown_1.faArrowDown,
        Upload: faUpload_1.faUpload,
        PersonCirclePlus: faPersonCirclePlus_1.faPersonCirclePlus,
        PersonCircleMinus: faPersonCircleMinus_1.faPersonCircleMinus,
        CircleXmark: faCircleXmark_1.faCircleXmark,
        LocationPin: faLocationPin_1.faLocationPin,
        BriefcaseBlank: faBriefcaseBlank_1.faBriefcaseBlank,
        SquareCheck: faSquareCheck_1.faSquareCheck,
        SquareA: faSquareA_1.faSquareA,
        AddressBook: faAddressBook_1.faAddressBook,
        ToggleOn: faToggleOn_1.faToggleOn,
        ToggleOff: faToggleOff_1.faToggleOff,
        Moon: faMoon_1.faMoon,
        Sun: faSun_1.faSun,
        Desktop: faDesktop_1.faDesktop,
        ChartDiagram: faChartDiagram_2.faChartDiagram,
        ListTree: faListTree_1.faListTree,
        FileMedical: faFileMedical_3.faFileMedical,
        Tags: faTags_1.faTags,
        WifiSlash: faWifiSlash_1.faWifiSlash,
        ScrewdriverWrench: faScrewdriverWrench_1.faScrewdriverWrench,
        Handshake: faHandshake_1.faHandshake,
        CalendarClock: faCalendarClock_2.faCalendarClock,
        ClipboardList: faClipboardList_3.faClipboardList,
        Gear: faGear_1.faGear,
        CakeCandles: faCakeCandles_1.faCakeCandles,
        Copy: faCopy_2.faCopy,
        FileCertificate: faFileCertificate_2.faFileCertificate,
        FolderTree: faFolderTree_2.faFolderTree,
        ChartUser: faChartUser_2.faChartUser,
        Memo: faMemo_2.faMemo,
        ChartMixed: faChartMixed_1.faChartMixed,
        Clock: faClock_2.faClock,
        FileCircleCheck: faFileCircleCheck_1.faFileCircleCheck,
        Infinity: padIconViewBox(faInfinity_1.faInfinity, 64),
        SquareUser: faSquareUser_2.faSquareUser
    },
    Regular: {
        Apartment: faApartment_2.faApartment,
        ArrowRightFromBracket: faArrowRightFromBracket_1.faArrowRightFromBracket,
        Bell: faBell_1.faBell,
        Briefcase: faBriefcase_1.faBriefcase,
        CalendarPlus: faCalendarPlus_1.faCalendarPlus,
        CircleExclamation: faCircleExclamation_2.faCircleExclamation,
        CircleQuestion: faCircleQuestion_2.faCircleQuestion,
        ChevronRight: faChevronRight_2.faChevronRight,
        ChevronLeft: faChevronLeft_2.faChevronLeft,
        ChevronUp: faChevronUp_1.faChevronUp,
        ChevronDown: faChevronDown_1.faChevronDown,
        Clock: faClock_1.faClock,
        HouseBlank: faHouseBlank_2.faHouseBlank,
        Fingerprint: faFingerprint_1.faFingerprint,
        FileContract: faFileContract_2.faFileContract,
        Question: faQuestion_1.faQuestion,
        Headset: faHeadset_2.faHeadset,
        Envelope: faEnvelope_1.faEnvelope,
        Key: faKey_1.faKey,
        ListUl: faListUl_1.faListUl,
        MoneyCheckDollar: faMoneyCheckDollar_1.faMoneyCheckDollar,
        Messages: faMessages_1.faMessages,
        PhoneVolume: faPhoneVolume_1.faPhoneVolume,
        Phone: faPhone_1.faPhone,
        LocationDot: faLocationDot_1.faLocationDot,
        QrCode: faQrcode_1.faQrcode,
        Signature: faSignature_1.faSignature,
        Star: faStar_2.faStar,
        PiggyBank: faPiggyBank_1.faPiggyBank,
        Plus: faPlus_1.faPlus,
        User: faUser_2.faUser,
        UserPen: faUserPen_1.faUserPen,
        Xmark: faXmark_1.faXmark,
        BuildingColumns: faBuildingColumns_1.faBuildingColumns,
        Pen: faPen_1.faPen,
        TrashCan: faTrashCan_1.faTrashCan,
        Check: faCheck_2.faCheck,
        InfoCircle: faInfoCircle_1.faInfoCircle,
        Info: faInfo_1.faInfo,
        Calendar: faCalendar_1.faCalendar,
        Circle: faCircle_1.faCircle,
        HeartPulse: faHeartPulse_1.faHeartPulse,
        Eye: faEye_1.faEye,
        EyeSlash: faEyeSlash_1.faEyeSlash,
        Tooth: faTooth_1.faTooth,
        Glasses: faGlasses_1.faGlasses,
        Gear: faGear_2.faGear,
        FileLines: faFileLines_1.faFileLines,
        ArrowDownToLine: faArrowDownToLine_1.faArrowDownToLine,
        BookOpen: faBookOpen_1.faBookOpen,
        ArrowUpRightFromSquare: faArrowUpRightFromSquare_1.faArrowUpRightFromSquare,
        ScaleBalanced: faScaleBalanced_2.faScaleBalanced,
        AlarmClock: faAlarmClock_3.faAlarmClock,
        Lock: faLock_1.faLock,
        Android: faAndroid_1.faAndroid,
        Apple: faApple_1.faApple,
        ArrowRight: faArrowRight_2.faArrowRight,
        Megaphone: faMegaphone_3.faMegaphone,
        CircleXmark: faCircleXmark_2.faCircleXmark,
        PersonCirclePlus: faPersonCirclePlus_3.faPersonCirclePlus,
        PersonCircleMinus: faPersonCircleMinus_3.faPersonCircleMinus,
        Buildings: faBuildings_1.faBuildings,
        IdBadge: faIdBadge_1.faIdBadge,
        Copy: faCopy_1.faCopy,
        ClipboardList: faClipboardList_2.faClipboardList,
        Memo: faMemo_1.faMemo,
        FaceViewfinder: faFaceViewfinder_1.faFaceViewfinder,
        Square: faSquare_1.faSquare,
        Filter: faFilter_1.faFilter,
        FileMedical: faFileMedical_1.faFileMedical,
        CalendarWeek: faCalendarWeek_1.faCalendarWeek,
        CalendarDays: faCalendarDays_1.faCalendarDays,
        Repeat: faRepeat_1.faRepeat,
        Retirement: faMoneyBillTrendUp_1.faMoneyBillTrendUp,
        Tags: faTags_2.faTags,
        ClipboardCheck: faClipboardCheck_1.faClipboardCheck,
        MoneyCheckPen: faMoneyCheckPen_1.faMoneyCheckPen,
        MoneyCheckDollarPen: faMoneyCheckDollarPen_2.faMoneyCheckDollarPen,
        Users: faUsers_1.faUsers,
        Table: faTable_1.faTable,
        CalendarCheck: faCalendarCheck_2.faCalendarCheck,
        ScrewdriverWrench: faScrewdriverWrench_2.faScrewdriverWrench,
        CakeCandles: faCakeCandles_2.faCakeCandles,
        Columns: faColumns_1.faColumns,
        Unlink: faUnlink_1.faUnlink,
        Link: faLink_1.faLink,
        Google: faGoogle_1.faGoogle,
        Microsoft: faMicrosoft_1.faMicrosoft,
        ChartLineUp: faChartLineUp_2.faChartLineUp,
        DisplayChartUp: faDisplayChartUp_1.faDisplayChartUp,
        Infinity: padIconViewBox(faInfinity_2.faInfinity, 64)
    },
    Light: {
        Headset: faHeadset_3.faHeadset,
        CalendarPlus: faCalendarPlus_2.faCalendarPlus,
        PhoneVolume: faPhoneVolume_2.faPhoneVolume,
        Briefcase: faBriefcase_3.faBriefcase,
        Messages: faMessages_2.faMessages,
        FileLines: faFileLines_2.faFileLines,
        Envelope: faEnvelope_3.faEnvelope
    },
    DuoTone: {
        Gifts: faGifts_1.faGifts,
        PiggyBank: faPiggyBank_2.faPiggyBank,
        SquareUser: faSquareUser_1.faSquareUser,
        Computer: faComputer_1.faComputer,
        MoneyBill1: faMoneyBill1_2.faMoneyBill1,
        Headset: faHeadset_1.faHeadset,
        AlarmClock: faAlarmClock_1.faAlarmClock,
        MoneyCheckDollar: faMoneyCheckDollar_3.faMoneyCheckDollar,
        FolderTree: faFolderTree_1.faFolderTree,
        Books: faBooks_1.faBooks,
        ScaleBalanced: faScaleBalanced_1.faScaleBalanced,
        PeopleGroup: faPeopleGroup_1.faPeopleGroup,
        Pen: faPen_2.faPen,
        Briefcase: faBriefcase_2.faBriefcase,
        CalendarPlus: faCalendarCirclePlus_1.faCalendarCirclePlus,
        CalendarCheck: faCalendarCheck_1.faCalendarCheck,
        CalendarXmark: faCalendarXmark_1.faCalendarXmark,
        CalendarClock: faCalendarClock_1.faCalendarClock,
        Envelope: faEnvelope_2.faEnvelope,
        HouseUser: faHouseUser_1.faHouseUser,
        BuildingColumns: faBuildingColumns_3.faBuildingColumns,
        MessageXmark: faMessageXmark_1.faMessageXmark,
        MessageCheck: faMessageCheck_1.faMessageCheck,
        ChartUser: faChartUser_1.faChartUser,
        Megaphone: faMegaphone_2.faMegaphone,
        FileImport: faFileImport_1.faFileImport,
        PollPeople: faPollPeople_1.faPollPeople,
        PersonCirclePlus: faPersonCirclePlus_2.faPersonCirclePlus,
        PersonCircleMinus: faPersonCircleMinus_2.faPersonCircleMinus,
        Key: faKey_3.faKey,
        ClipboardQuestion: faClipboardQuestion_1.faClipboardQuestion,
        IslandTropical: faIslandTropical_1.faIslandTropical,
        FileUser: faFileUser_1.faFileUser,
        FileShield: faFileShield_1.faFileShield,
        ChartLineUp: faChartLineUp_1.faChartLineUp,
        FileCertificate: faFileCertificate_1.faFileCertificate,
        FileLines: faFileLines_3.faFileLines,
        FaceHeadBandage: faFaceHeadBandage_1.faFaceHeadBandage,
        Gavel: faGavel_1.faGavel,
        SackDollar: faSackDollar_1.faSackDollar,
        ChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar_1.faChartPieSimpleCircleDollar,
        ClipboardMedical: faClipboardMedical_1.faClipboardMedical,
        FilesMedical: faFilesMedical_1.faFilesMedical,
        CarBurst: faCarBurst_1.faCarBurst,
        HeartPulse: faHeartPulse_3.faHeartPulse,
        Tooth: faTooth_3.faTooth,
        Glasses: faGlasses_3.faGlasses,
        HandshakeAngle: faHandshakeAngle_1.faHandshakeAngle,
        FileInvoiceDollar: faFileInvoiceDollar_1.faFileInvoiceDollar,
        FileContract: faFileContract_3.faFileContract,
        Balloons: faBalloons_1.faBalloons,
        LocationPlus: faLocationPlus_1.faLocationPlus,
        LocationPen: faLocationPen_1.faLocationPen,
        ClipboardList: faClipboardList_1.faClipboardList,
        EnvelopeOpenText: faEnvelopeOpenText_1.faEnvelopeOpenText,
        MoneyEdit: faMoneyCheckDollarPen_1.faMoneyCheckDollarPen,
        AddressBook: faAddressBook_2.faAddressBook,
        FolderGear: faFolderGear_1.faFolderGear,
        FileMedical: faFileMedical_2.faFileMedical,
        MoneyCheckEditAlt: faMoneyCheckEditAlt_1.faMoneyCheckEditAlt,
        CalendarEdit: faCalendarEdit_1.faCalendarEdit,
        CircleHalfStroke: faCircleHalfStroke_1.faCircleHalfStroke,
        ChartDiagram: faChartDiagram_1.faChartDiagram,
        Calendar: faCalendar_3.faCalendar,
        CakeCandles: faCakeCandles_3.faCakeCandles,
        Medal: faMedal_1.faMedal,
        CircleInfo: faCircleInfo_1.faCircleInfo,
        ChalkboardTeacher: faChalkboardTeacher_2.faChalkboardTeacher,
        Tags: faTags_3.faTags,
        Memo: faMemo_3.faMemo,
        AddressCard: faAddressCard_2.faAddressCard,
        Certificate: faFileCertificate_1.faFileCertificate,
        Check: faCheck_3.faCheck,
        FolderMagnifyingGlass: faFolderMagnifyingGlass_1.faFolderMagnifyingGlass,
        FolderXmark: faFolderXmark_1.faFolderXmark,
    }
};
